export const CodeViewer = ({ file }) => {
  return (
    <div className="font-mono pt-1">
      {file.map((line, i) => (
        <div
          key={i}
          className="inline-flex gap-2 min-w-full w-fit overflow-x-scroll px-1"
        >
          <p className=" text-gray-300 border-gray-500">{i + 1}</p>
          <p className="flex-grow whitespace-pre text-gray-700 w-full overflow-x-scroll">
            {line}
          </p>
        </div>
      ))}
    </div>
  );
};
